// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"52":"8ba85591","287":"d815b497","746":"c59e230f"}[chunkId] + ".js";
};